import React, { useState } from 'react';
import { View, Switch, Text, TextInput } from 'react-native';
import styles from '@stylesheet';
import { ValidationType } from '../types/validatorTypes';
import updateStoreHandler from '../utils/updateStoreHandler';
import ComponentRenderer from './ComponentRenderer';
import defaultValComponents, { ValidationComponentType } from '../utils/defaultValComponents';

const SwitchValidation = ({ item, index }: ValidationType) => {
  const initialObject = item || {}; // Ensure item is not null or undefined
  const initialMap = new Map(Object.entries(initialObject));
  const [validationOptions, setValidationOptions] = useState(initialMap);

const updateMap = (key, value) => {
  setValidationOptions((prevMap) => new Map(prevMap.set(key, value)));
}

  // Define an array of configuration objects for each component
  const validationComponents: ValidationComponentType[] = [
    ...defaultValComponents,
    { key: 'helpText', label: 'Help Text', type: 'textInput' },
    { key: 'trueValue', label: 'True Value', type: 'textInput' },
    { key: 'falseValue', label: 'False Value', type: 'textInput' },
  ];

  const handleValidationChange = (value, key) => {
    updateMap(key, value);
    const options = { value, type: key };
    updateStoreHandler({ index, option: options });
  };


  return (
    <View style={[styles.validationView, { flexWrap: 'wrap' }]}>
      {validationComponents.map((component) => (
        <View key={component.key} style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', position: 'relative', flexWrap: 'wrap' }}>
          {
            component.type === 'switch' &&
            <Text style={{ flex: 1 }}>{component.label}</Text>
          }
          <ComponentRenderer item={item} component={component} index={index} />
        </View>
      ))}
    </View>
  );
};

export default SwitchValidation;
